import { computed, inject, Injectable } from '@angular/core';
import { AuthService } from './auth-service.service';

@Injectable({
  providedIn: 'root',
})
export class RolesButtonsService {
  private authService = inject(AuthService);

  isAccessible(role: string) {
    if (this.isAdminUser()) {
      return true;
    }
    return this.authService.hasRole(role) || this.authService.hasRole('mile-novo-' + role);
  }

  private checkPermission(role: string): boolean {
    if (this.isAdminUser()) {
      return true;
    }
    return this.authService.hasRole(role) || this.authService.hasRole('mile-novo-' + role);
  }

  canAll = (perms: string[]) => {
    return computed(() => {
      if (this.isAdminUser()) {
        return true;
      }
      const roles = this.authService.getRoles();
      return perms.every((p) => roles.includes(p) || roles.includes('mile-novo-' + p));
    });
  };

  canAny = (perms: string[]) => {
    return computed(() => {
      if (this.isAdminUser()) {
        return true;
      }
      const roles = this.authService.getRoles();
      return perms.some((p) => roles.includes(p) || roles.includes('mile-novo-' + p));
    });
  };

  private isAdminUser() {
    const roles = this.authService.getRoles();
    const email = this.authService.getUserEmail();

    return (
      roles.includes('Administrator') ||
      roles.includes('admin') ||
      roles.includes('mile-administrator') ||
      roles.includes('mile-admin') ||
      roles.includes('sga-administrador') ||
      email === 'admin@gmail.com'
    );
  }
}
